import React, { useState, useCallback } from "react";
import Select from "react-select";
import { ActionButton } from "@talentbait/shared-components";
import {
  simpleSelectStyles,
  FormContainer,
  FormGroup,
  Input,
  Label,
  ButtonContainer,
  InternalsLink
} from "./Modals.styled";
import { useTranslation } from "react-i18next";
import { ModalContent } from "./Modals.styled";
import { LANGUAGE_WEIGHT_OPTIONS } from "../Profile.constants";
import { withRefluxStore } from "../../../Stores";

const AddWeightedOptionForm = ({
  req,
  selectedIndex,
  filteredSkills,
  onSubmit,
  onCancel,
  // store
  userProfile
}) => {
  const { t } = useTranslation();

  const [option, setOption] = useState({
    name: "",
    weight: 0,
    selected: false,
    category
  });

  const userIsAdmin = userProfile?.superRank === "admin";
  const category = selectedIndex !== null ? req.category : null;

  let availableSkills = [];

  if (selectedIndex !== null) {
    availableSkills = filteredSkills
      .filter((skill) => !req.options.some((option) => option.name === skill))
      .map((skill) => ({ label: skill, value: skill }));
  }

  const handleSkillSelect = useCallback(
    (selectedOption) => {
      setOption({ ...option, name: selectedOption?.value || "" });
    },
    [option]
  );

  const handleSubmit = (e) => {
    e.preventDefault();
    onSubmit(option);
  };

  const validateWeight = useCallback(
    (value) => {
      if (category === "languages") {
        return value; // No validation needed for language levels
      }
      const weight = parseInt(value, 10) || 0;
      return Math.min(5, Math.max(0, weight));
    },
    [category]
  );

  const handleWeightChange = useCallback(
    (selectedOption) => {
      if (category === "languages") {
        setOption({ ...option, weight: selectedOption?.value || null });
      } else {
        setOption({ ...option, weight: validateWeight(selectedOption.target.value) });
      }
    },
    [category, option, validateWeight]
  );

  return (
    <ModalContent>
      <h1>{t("Add New Option")}</h1>
      <FormContainer onSubmit={handleSubmit}>
        <FormGroup>
          <Label>{t("Option")}:</Label>
          <Select
            options={availableSkills}
            onChange={handleSkillSelect}
            value={availableSkills.find((opt) => opt.value === option.name)}
            styles={simpleSelectStyles}
            placeholder={t("Select an option")}
            isLoading={availableSkills?.length === 0}
            required
          />
        </FormGroup>

        <FormGroup>
          <Label>{category === "languages" ? `${t("Level")}:` : `${t("Weight")}(0 - 5):`}</Label>
          {category === "languages" ? (
            <Select
              options={LANGUAGE_WEIGHT_OPTIONS(t)}
              onChange={handleWeightChange}
              value={LANGUAGE_WEIGHT_OPTIONS(t).find((opt) => opt.value === option.weight)}
              styles={simpleSelectStyles}
              placeholder={t("Select a level")}
              required
            />
          ) : (
            <Input
              type="number"
              min="0"
              max="5"
              value={option.weight}
              onChange={handleWeightChange}
              required
            />
          )}
        </FormGroup>

        {userIsAdmin && (
          <InternalsLink
            target="_blank"
            rel="noreferrer"
            href="https://internal.talentbait.de/admin/domain-skills"
          >
            {t("Open domain skill page")}
          </InternalsLink>
        )}

        <ButtonContainer>
          <ActionButton
            type="submit"
            variant="create"
            disabled={!option.name || option.weight === null}
            text={t("Add")}
          />
          <ActionButton variant="secondary" onClick={onCancel} text={t("Cancel")} />
        </ButtonContainer>
      </FormContainer>
    </ModalContent>
  );
};

export default withRefluxStore(AddWeightedOptionForm, [], ["userProfile"]);
